const vacancyList = [
  {
    title: 'Service Monteur Zonnepanelen',
    tags: [
      {
        text: 'Hoogeveen',
        icon: 'location'
      },
      {
        text: 'MBO',
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur',
    tags: [
      {
        text: 'Nieuwegein',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur2',
    tags: [
      {
        text: 'Maarssen',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Service Monteur Zonnepanelen',
    tags: [
      {
        text: 'Hoogeveen',
        icon: 'location'
      },
      {
        text: 'MBO',
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur3',
    tags: [
      {
        text: 'Nieuwegein',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur4',
    tags: [
      {
        text: 'Maarssen',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Service Monteur Zonnepanelen',
    tags: [
      {
        text: 'Hoogeveen',
        icon: 'location'
      },
      {
        text: 'MBO',
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur',
    tags: [
      {
        text: 'Nieuwegein',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur',
    tags: [
      {
        text: 'Maarssen',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Service Monteur Zonnepanelen',
    tags: [
      {
        text: 'Hoogeveen',
        icon: 'location'
      },
      {
        text: 'MBO',
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur',
    tags: [
      {
        text: 'Nieuwegein',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  },
  {
    title: 'Junior Koelmonteur',
    tags: [
      {
        text: 'Maarssen',
        icon: 'location'
      },
      {
        icon: 'award'
      }
    ]
  }
];

export default vacancyList;
